import { TrackingDataLayer } from '@/components/extension/tracking-data-layer'
import { useBotNoticeErrorMutation } from '@/hooks/react-query/bot/use-bot-notice-error.mutation'
import { ETrackingEvent } from '@/lib/gtm/type'
import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

const publicEnv = process.env.NEXT_PUBLIC_ENV

export const CollectionEmptyProductList = () => {
  const { mutateAsync: sendErrorNotice } = useBotNoticeErrorMutation()
  const t = useTranslations('collection_page.message')

  useEffect(() => {
    handleSendErrorNotice()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSendErrorNotice = async () => {
    if (publicEnv !== 'local') {
      sendErrorNotice(
        `ENV:${publicEnv?.toUpperCase()} | Không tìm thấy sản phẩm nào | ${window?.location?.href}`
      )
    }
  }

  return (
    <>
      <div className='col-span-full'>
        <p className='no-product-found text-center text-sm text-neutral-900/60'>
          {t('no_product_found')}
        </p>
      </div>
      <TrackingDataLayer
        data={{
          event: ETrackingEvent.ProductNotFound,
          url: window?.location?.href,
        }}
      />
    </>
  )
}
